// extracted by mini-css-extract-plugin
export default {"heading":"SupplementNutrition-module__heading__zXLdw","supplement-nutrition":"SupplementNutrition-module__supplement-nutrition__ljJqs"};